import dayjs from 'dayjs';

type getDateType = (date: number | string, format?: string) => string;

export const getDate: getDateType = (date, format = 'DD.MM.YYYY') => {
  return dayjs(Number(date)).format(format);
};
